import React from 'react';
import SecondImage from "../assets/bookcallImage.jpg";

function BookCall() {
    return (
      <section>
      <div className="mx-auto w-full sm:p-0 p-5">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          {/* Left Column (Text and Buttons) */}
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px]">
            <div className="flex items-center rounded-md py-1">
              {/* <p className="text-sm uppercase mb-12">ABOUT</p> */}
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
            BOOST YOUR ONLINE VISIBILITY & <span className='italic text-black bg-[#CFF098]'>ATTRACT MORE CUSTOMERS</span> WITH TAILORED WEB DESIGN & SEO. If you need a <span className='italic text-black bg-[#CFF098]'>website designer</span>, let's discuss how we can help.
            </h4>
            <p className="text-sm text-white sm:text-xl">
            Specifically designed for women-run small and medium businesses, we'll help you improve search rankings and drive client growth. Discuss your challenges and get an action-oriented plan to streamline your online presence. Many have chosen our professional web design company.
            </p>


            <div className="flex flex-col gap-4 font-regular sm:flex-row mt-10">
              <a href="/freereviewlanding" className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60">
                <p>BOOK FREE WEBSITE & SEO REVIEW →</p>
              </a>
            </div>
            <p className='mt-6 mb-6 text-xl italic'>Discover the digital strategies that have helped over 200+ businesses thrive. Considering to hire web designers? Let's chat.</p>
          </div>

          {/* Right Column (Image) */}
          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="Portrait of a smiling women entrepreneur - Her Growth Co"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
      );
    }


export default BookCall